module.exports = __webpack_public_path__ + "assets/img/block-left-hover-39c4849e.png";